<template>
  <div class="tests" :class="{ 'page-tests-kpmg': getProcessName === PROCESS_NAMES.KPMG }">
    <vtitle />

    <div v-if="loaded" class="page_tests">
      <div class="row-block col-block">
        <vinput
          v-model="name"
          class="page_tests_input"
          :placeholder="$tr('vacancy.tests.form.name')"
          focus
          :error="name_error"
        />

        <vtextarea
          v-model="description"
          class="page_tests_textarea"
          :height="84"
          :placeholder="$tr('vacancy.tests.form.description')"
        />
      </div>

      <div class="row-block">
        <div
          v-for="item in page_views"
          :key="item.id"
          class="page_view"
          :class="{ active: item.id === page_view, sing: item.id === 0 }"
          @click="page_view = item.id"
        >
          <vfocus-field class="pointer">
            <vcircle :value="item.id == page_view" />
          </vfocus-field>

          <label class="page_view_label">{{ item.name }}</label>
        </div>
      </div>

      <div class="row-block checkboxer">
        <vchecklabel
          v-model="is_answer_paste_disabled"
          :label="$tr('vacancy.tests.form.is_answer_paste_disabled.checkbox')"
        />
      </div>

      <div class="row-block checkboxer first" :class="{ mrb10: page_view === 0 }">
        <vchecklabel
          v-model="question_shuffle"
          :label="$tr('vacancy.tests.form.is_question_shuffle.checkbox')"
          :tooltip="{
            content: $tr('vacancy.tests.form.randomiztion.tooltip'),
            placement: 'auto',
            classes: 'tight'
          }"
        />

        <vinput
          v-model="question_limit"
          class="input_block"
          valuetype="number"
          :disabled="!question_shuffle"
          center
          :min="1"
          :max="questions.length"
          :placeholder="$tr('vacancy.tests.form.question_limit.input')"
        />
      </div>

      <div class="row-block checkboxer" :class="{ mrb10: page_view === 0 }">
        <vchecklabel
          v-model="calculate_test_status"
          :label="$tr('vacancy.tests.form.required_score.checkbox')"
          :tooltip="{
            content: $tr('vacancy.tests.form.required_score.tooltip'),
            placement: 'auto',
            classes: 'tight'
          }"
        />

        <vinput
          v-model="required_score"
          class="input_block"
          valuetype="number"
          :disabled="!calculate_test_status"
          :min="1"
          :max="questions.length"
          center
        />
      </div>

      <div
        v-if="testDropoutEnabled"
        class="row-block checkboxer"
        :class="{ mrb10: page_view === 0, last: page_view !== 0 }"
      >
        <vchecklabel
          v-model="is_dropout_enabled"
          :label="`${$tr('vacancy.tests.form.test_dropdout.checkbox')} ${required_score}`"
          :tooltip="{
            content: $tr('vacancy.tests.form.test_dropdout.tooltip'),
            placement: 'right',
            classes: 'tight'
          }"
        />
      </div>

      <div v-if="page_view === 0" class="row-block checkboxer last">
        <vchecklabel
          v-model="time_limit_enabled"
          :label="$tr('vacancy.tests.form.time_limit_enabled.checkbox')"
          :tooltip="{
            content: $tr('vacancy.tests.form.timelimit.tooltip'),
            placement: 'auto',
            classes: 'tight'
          }"
        />
        <div class="test-time-wrapper">
          <masked-input
            v-model="all_test_limit.h"
            :class="{
              error: (is_timer_less_duration && time_limit_enabled) || (!isTimeValid && time_limit_enabled)
            }"
            :mask="[/[0-9]/, /[0-9]/]"
            keep-char-positions
            :disabled="!time_limit_enabled"
            class="input_block"
            type="text"
            placeholder="00"
            @input="set_time_limit"
          />

          <span>:</span>

          <masked-input
            v-model="all_test_limit.m"
            class="input_block"
            :class="{
              error: (is_timer_less_duration && time_limit_enabled) || (!isTimeValid && time_limit_enabled)
            }"
            type="text"
            placeholder="00"
            :mask="[/[0-5]/, /[0-9]/]"
            keep-char-positions
            :disabled="!time_limit_enabled"
            @input="set_time_limit"
          />

          <span>:</span>

          <masked-input
            v-model="all_test_limit.s"
            class="input_block"
            :class="{
              error: (is_timer_less_duration && time_limit_enabled) || (!isTimeValid && time_limit_enabled)
            }"
            type="text"
            placeholder="00"
            :mask="[/[0-5]/, /[0-9]/]"
            keep-char-positions
            :disabled="!time_limit_enabled"
            @input="set_time_limit"
          />
        </div>
      </div>

      <div v-if="hasAnticheating" class="row-block checkboxer last">
        <vchecklabel
          v-model="is_camera_required"
          :label="$tr('vacancy.settings.modules.anticheating.checkbox')"
          :tooltip="{
            content: $tr('vacancy.settings.modules.anticheating.tooltip'),
            placement: 'auto',
            classes: 'tight'
          }"
        />
      </div>

      <div
        v-if="time_limit_enabled && is_timer_less_duration && page_view === 0"
        class="row-block error time-error"
        v-html="$tr('vacancy.tests.media.timeLess', { minutes: Math.ceil(duration_sum / 60) })"
      ></div>

      <div v-if="questions.length > 0" class="row-block col-block col-block--last">
        <sortable-list v-model="questions_list" @start="drag = true" @stop="drag = false">
          <transition-group type="transition">
            <sortable-item v-for="(item, index) in questions_list" :key="item._id">
              <div class="sortable-question">
                <!-- v-if kpmg question if kpmg and add :test-id="test.id" prop for it -->
                <question-kpmg
                  :disabled_del="questions.length === 1"
                  :item="item"
                  :test-id="test.id"
                  :i="index"
                  :timer="page_view === 1"
                  :active_focus="active_focus"
                  :check_errors="check_errors"
                  :is_page_single="page_view === 0"
                  @input="update_question"
                  @update="set_has_changes"
                  @change_duration="change_duration"
                  @set_timer_less_duration="set_timer_less_duration"
                />

                <!-- <question
                  v-else
                  :disabled_del="questions.length === 1"
                  :item="item"
                  :i="index"
                  :timer="page_view === 1"
                  :active_focus="active_focus"
                  :check_errors="check_errors"
                  :is_page_single="page_view === 0"
                  @input="update_question"
                  @update="set_has_changes"
                  @change_duration="change_duration"
                  @set_timer_less_duration="set_timer_less_duration"
                /> -->
              </div>
            </sortable-item>
          </transition-group>
        </sortable-list>
      </div>

      <div class="row-block page_tests__buttons">
        <vbutton label="vacancy.tests.form.button.add_question" color="grey" type="add" @click="add_item(true)" />

        <vbutton
          class="vacancy-button"
          label="common.save"
          :loading="loading"
          :disabled="duration_validate_disabled || timerDisabled || loading"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import MaskedInput from 'vue-text-mask';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { formatTimeValue, cleanTimeValue } from '@/_helpers/utils.js';
// import question from './components/question';
import questionKpmg from '@/process/kpmg/components/vacancy/tests/components/question';
import SortableList from '@/components_new/vsortable/vsortable-list';
import SortableItem from '@/components_new/vsortable/vsortable-item';
import vtitle from '@/routes_new/inner/vacancy/components/vtitle.vue';
import { cloneDeep } from 'lodash';
import PROCESS_NAMES from '@/process/names.js';

export default {
  name: 'VacancyTestsDefault',

  components: {
    // question,
    questionKpmg,
    SortableList,
    SortableItem,
    vtitle,
    MaskedInput
  },

  data() {
    return {
      PROCESS_NAMES,
      active: false,
      name: '',
      description: '',
      page_view: 0,
      question_limit: 0,
      question_shuffle: false,
      time_limit_enabled: false,
      is_camera_required: false,
      loading: false,
      is_answer_paste_disabled: true,
      active_focus: false, // определяем надо ли дочернему компоненту использовать автофокус, это полезно при первой загрузке страницы
      time_limit: 0,
      all_test_limit: {
        h: '',
        m: '',
        s: ''
      },

      page_views: [
        {
          id: 0, // all questions on one page, old 'single'
          name: this.$tr('vacancy.tests.form.pageview.single')
        },
        {
          id: 1, // one page one question, old 'separate_per_question'
          name: this.$tr('vacancy.tests.form.pageview.separate_per_question')
        }
      ],

      check_errors: false,
      name_error: '',
      questions_duration: [],
      is_separate_timer_less_duration: false,
      drag: false,
      calculate_test_status: false,
      is_dropout_enabled: false,
      required_score: 0,
      timeRegex: /[0-9][0-9]:[0-5][0-9]:[0-5][0-9]/g
    };
  },

  computed: {
    ...mapGetters('tests', {
      tests: 'list',
      has_changes: 'has_changes',
      loaded: 'loaded',
      saved: 'saved'
    }),

    ...mapGetters('questions', { questions: 'list', questions_has_answers: 'questions_has_answers' }),

    ...mapGetters('vacancy_new/modules', ['hasAnticheating']),

    ...mapGetters('process', ['getProcessName']),

    time_limit_temp() {
      return `${this.all_test_limit.h}:${this.all_test_limit.m}:${this.all_test_limit.s}`;
    },

    testDropoutEnabled() {
      const testDropout = this.modules.find(item => item.id == 'test-dropout');
      return testDropout.is_active;
    },

    questions_list: {
      get() {
        return this.questions || [];
      },

      set(questions) {
        this.$store.commit('questions/sort_change', questions);
        this.set_has_changes(true);
      }
    },

    vacancy_id() {
      return this.$store.getters['vacancy_new/item'].id;
    },

    modules() {
      return this.$store.getters['vacancy_new/modules/list'];
    },

    is_module_videointerview_active() {
      if (!this.modules || !this.modules.length) {
        return false;
      }

      return this.modules.find(item => item.id === 'videointerview' && item.is_active);
    },

    test() {
      return this.tests[0];
    },

    is_timer_less_duration() {
      if (!this.time_limit || !this.duration_sum) {
        return false;
      }

      return this.time_limit <= this.duration_sum;
    },

    duration_sum() {
      if (!this.questions_duration || !this.questions_duration.length) {
        return 0;
      }
      let duration = 0;

      this.questions_duration.map(item => {
        duration = duration + item.duration;
      });

      return duration;
    },

    duration_validate_disabled() {
      const single_validate_error = this.time_limit_enabled && this.is_timer_less_duration && this.page_view === 0;
      const separate_validate_error = this.is_separate_timer_less_duration;
      return single_validate_error || separate_validate_error;
    },

    isTimeValid() {
      if (!this.time_limit_enabled) {
        return true;
      }
      if (!this.time_limit_temp) {
        return false;
      }

      return !!this.time_limit_temp.match(this.timeRegex) && !!this.time_limit_temp.match(this.timeRegex).length;
    },

    timerDisabled() {
      let isInvalid = false;

      if (this.page_view === 0) {
        return !this.isTimeValid;
      } else {
        this.questions_list.forEach(item => {
          if (
            item.time_limit_enabled &&
            (!item._time_limit ||
              !item._time_limit.match(this.timeRegex) ||
              !item._time_limit.match(this.timeRegex).length)
          ) {
            isInvalid = true;
          }
        });
      }

      return isInvalid;
    }
  },

  watch: {
    active: function () {
      this.set_has_changes(true);
    },

    name: function () {
      this.set_has_changes(true);
    },

    description: function () {
      this.set_has_changes(true);
    },

    page_view: function () {
      this.set_has_changes(true);
    },

    question_limit: function () {
      this.set_has_changes(true);
    },

    question_shuffle: function () {
      this.set_has_changes(true);
    },

    time_limit_enabled: function () {
      this.set_has_changes(true);
    },

    is_camera_required: function () {
      this.set_has_changes(true);
    },

    time_limit: function () {
      this.set_has_changes(true);
    }
  },

  async created() {
    await this.load();

    if (this.test.id !== undefined && this.getProcessName === PROCESS_NAMES.KPMG) {
      await this.fetchQuestions(this.test.id);
      this.fetchAnswers(this.test.id);
      this.setDefaultValuesForMaxScore({
        questions: this.questions_list,
        testId: this.test.id
      });
    }
  },

  destroyed() {
    this.$store.commit('tests/clear');
    this.$store.commit('questions/clear');
    this.RESET_VARIABLES();
  },

  methods: {
    ...mapMutations('questions', ['RESET_VARIABLES']),

    ...mapActions('process/kpmg/test', ['fetchQuestions', 'fetchAnswers', 'setDefaultValuesForMaxScore']),

    set_time_limit() {
      let time = `${this.all_test_limit.h ? this.all_test_limit.h : '00'}:`;

      time += `${this.all_test_limit.m ? this.all_test_limit.m : '00'}:`;
      time += `${this.all_test_limit.s ? this.all_test_limit.s : '00'}`;

      this.time_limit = cleanTimeValue(time);
    },

    async add_item(clicked) {
      if (clicked) {
        this.active_focus = true;
      }

      let params = { _new: true, chart_config: [], variables: [] };
      let sort_order = 0;

      if (this.questions && this.questions.length) {
        this.questions.forEach(item => {
          if (item.sort_order && item.sort_order > sort_order) {
            sort_order = item.sort_order;
          }
        });
      }
      if (sort_order) {
        params.sort_order = +sort_order + 1;
      }

      this.$store.commit('questions/add_item', params);
      this.set_has_changes(true);
    },

    update_question(v) {
      this.$store.commit('questions/update_item', v);
      if (!!v.type && v.type !== 'value') {
        this.$store.commit('questions/set_answer_is_valid', { question_id: v.id });
      }
    },

    set_has_changes(v) {
      if (this.name !== '') {
        this.name_error = '';
      }
      this.$store.commit('tests/set_has_changes', v);
    },

    validate() {
      this.name_error = this.name ? '' : this.$tr('common.requiredField');
      this.check_errors = true;
      return this.questions_has_answers;
    },

    async loadStageTest() {
      await Axios.get(`/v3/vacancy-stages/test/${this.vacancy_id}`).then(response => {
        this.name = response.data.name;
        this.description = response.data.description;
      });
    },

    async saveStageTest(payload) {
      return await Axios.patch(`/v3/vacancy-stages/test/${this.vacancy_id}`, payload);
    },

    async save() {
      this.loading = true;
      let valid = this.validate();

      if (!valid) {
        this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text'));
        this.loading = false;

        return false;
      }

      if (this.saved) {
        const stageData = { name: this.name, description: this.description };

        await this.saveStageTest(stageData);

        this.$store.commit('tests/set_saved', false);
        this.$store.commit('questions/prepare_to_save');
        this.$store.commit('questions/update_correct_answer');
        this.$store.commit('questions/update_valid');

        let disable_time_limit = !this.time_limit_enabled && this.page_view === 0;

        // change value to variable before save (ex, 10 => {{a}} )
        let questions = this.questions.map(item => {
          const configs = cloneDeep(item.chart_config);

          configs.forEach((config, indexChart) => {
            if (config.type === 'combo') {
              config.type = 'line';
            }

            config.options = this.$store.getters['questions/getApexOptions']({
              questionId: item.id,
              indexChart: indexChart
            });

            // если в график были вставленны переменные, то перед отправкой заменяем значения переменными
            if (config.variables !== undefined && config.variables.length > 0) {
              config.variables.forEach(variable => {
                if (config.type === 'pie' || config.type === 'donut') {
                  config.series[variable.indexData] = `{{${variable.variableName}}}`;
                } else {
                  config.series[variable.indexSeries].data[variable.indexData] = `{{${variable.variableName}}}`;
                }
              });
            }

            delete config.options.chart.xaxis;
            delete config.options.labels;
          });

          let data = {};

          if (disable_time_limit) {
            data = {
              ...item,
              chart_config: configs,
              time_limit: 0,
              time_limit_enabled: false
            };
          } else {
            data = {
              ...item,
              chart_config: configs
            };
          }

          return data;
        });

        let time_limit = disable_time_limit ? 0 : this.time_limit || 180;
        let data = {
          vacancy_id: this.vacancy_id,
          is_active: this.active,
          question_page_limit: this.page_view,
          question_limit: parseInt(this.question_limit),
          question_shuffle: this.question_shuffle,
          time_limit_enabled: this.time_limit_enabled,
          is_camera_required: this.is_camera_required,
          is_answer_paste_disabled: this.is_answer_paste_disabled,
          time_limit,
          questions,
          calculate_test_status: this.calculate_test_status,
          required_score: this.required_score,
          is_dropout_enabled: this.is_dropout_enabled
        };

        this.$store
          .dispatch('tests/save_all', data)
          .then(() => {
            this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text')); // уточнить текст для сохранения теста
          })
          .then(() => this.load())
          .then(() => {
            this.loading = false;
            this.check_errors = false;
            this.$store.commit('tests/set_saved', true);

            // if (is_continue) {
            //   this.set_has_changes(false);

            //   const next_section = this.is_module_videointerview_active ? 'video' : 'integration';
            //   this.$router.push({ path: `/vacancies/${this.vacancy_id}/${next_section}` });
            // }
          })
          .catch(e => {
            this.loading = false;
            this.$store.commit('tests/set_saved', true);
            this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text')); // уточнить текст для ошибки сохранения теста
            throw e;
          });
      }
    },

    async load() {
      await this.loadStageTest();

      return this.$store.dispatch('tests/load', this.vacancy_id).then(r => {
        this.id = r.id;
        this.page_view = r.question_page_limit;
        this.active = this.test.is_active;
        this.question_shuffle = r.question_shuffle;
        this.question_limit = r.question_limit;
        this.calculate_test_status = r.calculate_test_status;
        this.required_score = r.required_score;
        this.time_limit = r.time_limit;
        this.is_camera_required = r.is_camera_required;
        this.is_answer_paste_disabled = r.is_answer_paste_disabled;

        if (this.time_limit === 0) {
          this.time_limit = 30;
        }

        const time = formatTimeValue(this.time_limit, 'hh:mm:ss').split(':');
        this.all_test_limit.h = time[0];
        this.all_test_limit.m = time[1];
        this.all_test_limit.s = time[2];

        this.time_limit_enabled = this.test.time_limit_enabled;
        this.is_dropout_enabled = this.test.is_dropout_enabled;

        setTimeout(() => {
          this.set_has_changes(false);
        }, 0);

        return this.$store.dispatch('questions/set_list', r._embedded.questions).then(() => {
          if (this.questions.length === 0) {
            this.add_item();
          }
          if (Number(this.question_limit) === 0) {
            this.question_limit = this.questions.length ? this.questions.length : 1;
          }
        });
      });
    },

    change_duration(data) {
      if (this.questions_duration.find(item => item.id === data.id)) {
        let index = null;
        this.questions_duration.forEach((item, i) => {
          if (item.id === data.id) {
            index = i;
          }
        });

        this.questions_duration.splice(index, 1, data);
      } else {
        this.questions_duration.push(data);
      }
    },

    set_timer_less_duration(val) {
      this.is_separate_timer_less_duration = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.tests {
  max-width: 700px;
}

.page_tests {
  margin-top: 4px;

  &__buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    margin-bottom: 100px !important;
  }

  .row-block {
    display: flex;
    margin-bottom: 30px;
    align-items: stretch;

    &.checkboxer {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      height: 40px;

      ::v-deep {
        .vcheckbox_label {
          .checkbox_label {
            margin-left: 10px;
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 24px;
          }
        }
      }

      &.last {
        margin-bottom: 30px;
      }
    }
    &.col-block {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      &.col-block--last {
        margin-bottom: -25px;
      }

      span {
        outline: none;
        border: none;
        display: block;
        width: 100%;
        &:focus {
          outline: none;
          border: none;
        }
      }
    }
    .label {
      display: block;
      color: #333;
      font-size: 15px;
      margin-left: 10px;
    }
  }
  .page_tests_input {
    max-width: 100%;
    min-width: 100%;
    margin-bottom: 30px;
    margin-top: -6px;
  }
  .page_tests_textarea {
    max-width: 100%;
    min-width: 100%;
    min-height: 84px;
    max-height: 84px;
  }
  ::v-deep .page_tests_textarea.vtextarea {
    .textarea {
      padding: 8px 15px;
    }
  }
  .page_view {
    position: relative;
    min-width: 200px;
    max-width: 200px;
    min-height: 188px;
    max-height: 188px;
    box-sizing: border-box;
    border: 1px solid rgba(33, 51, 71, 0.14);
    border-left: 0;
    cursor: pointer;
    padding: 35px 16px;
    // background: url('/static/images/elements/page_view_one_g.svg') center 35px no-repeat;

    &:first-child {
      border-left: 1px solid rgba(33, 51, 71, 0.14);
    }

    &.active {
      background-color: #f4f5f7;
      // background-image: url('/static/images/elements/page_view_one_w.svg');
    }

    &.sing {
      // background-image: url('/static/images/elements/page_view_sing_g.svg');
      &.active {
        // background-image: url('/static/images/elements/page_view_sing_w.svg');
      }
    }

    .pointer {
      position: absolute;
      top: 10px;
      left: 10px;
    }

    .page_view_label {
      display: block;
      margin-top: 83px;
      text-align: center;
      word-wrap: break-word;
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 22px;
      text-align: center;
      letter-spacing: 0.005em;
      color: #233346;
    }
  }
  .question_block {
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .small_input {
    max-width: 60px;
    min-width: 60px;
    margin-left: 10px;

    ::v-deep {
      .input {
        padding: 1px 0px;
        min-height: 20px;
        max-height: 20px;
        width: 30px;
        min-width: auto;
      }
    }
  }
  .checkbox_label {
    margin-left: 20px;
  }
  .mrb10 {
    margin-bottom: 10px;
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    margin: 50px 0 100px;
    .vacancy-button:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.time-error {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.005em;
  color: #f65046;
  margin-top: -30px;
}

::v-deep input.input_block {
  width: 72px;
  padding: 8px 11px;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
}

::v-deep .input_block {
  margin-left: 8px;
  .input {
    width: 62px;
    padding: 8px 11px;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0;
    border: 1px solid #cccccc;
    border-radius: 2px;
  }
}

::v-deep.input_block {
  margin-left: 8px;
  .input {
    width: 62px;
    padding: 8px 11px;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0;
    border: 1px solid #cccccc;
    border-radius: 2px;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.sortable-chosen {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.sortable-question {
  padding-top: 10px;
  padding-left: 0;
}

.row-test {
  ::v-deep .sortable-question {
    margin-left: 0;
    margin-bottom: 75px;
  }
}

.test-time-wrapper {
  display: flex;
  align-items: center;

  ::v-deep .input_block {
    width: 43px;
    margin-right: 8px;
  }
}

.page-tests-kpmg {
  width: 100%;
  max-width: 700px;

  .input_block {
    width: 46px;
  }
}
</style>
